/* eslint-disable sort-keys */
const neutralColors = {
  WHITE: '#FFFFFF',
  NEUTRAL_50: '#FAFAFA',
  NEUTRAL_100: '#F5F5F5',
  NEUTRAL_200: '#EFEFEF',
  NEUTRAL_300: '#E2E2E2',
  NEUTRAL_400: '#BFBFBF',
  NEUTRAL_500: '#A0A0A0',
  NEUTRAL_600: '#777777',
  NEUTRAL_700: '#636363',
  NEUTRAL_800: '#444444',
  NEUTRAL_900: '#232323',
  BLACK: '#000000',
}

export default neutralColors
